import { message } from 'antd';

export const getLocationImage = async (locationImageFile: any, generateTaskImageUrl: any, uploadImageToS3: any) => {
    let file;
    let locationImageDetails;
    if (Array.isArray(locationImageFile) && locationImageFile.length > 0) {
        file = locationImageFile[0];
        const s3Data = {
            fileName: file?.name,
            pocContentType: file?.type?.split('/')?.[1],
            type: 'location_image',
        };

        const response = await generateTaskImageUrl(s3Data);
        if (response?.isSuccess) {
            const upload = await uploadImageToS3(
                new Blob([file as BlobPart], {
                    type: file?.type,
                }),
                response?.data?.pocSignedUrl,
                file?.type,
            );
            if (!upload.isSuccess) {
                message.error('Could not upload file');
                return null;
            }
            const s3UrlToReturn = upload.isSuccess ? response?.data?.pocImageUrl : null;
            locationImageDetails = s3UrlToReturn;
        } else {
            message.error('Could not upload file');
            return null;
        }
    }

    return locationImageDetails;
};
